import React from "react";
import "./App.css";
import Home from "./pages/Home";
import DisableInspect from "./components/DisableInspect";

const App = () => {
  return (
    <div className="main_app">
      <DisableInspect />
      <Home />
    </div>
  );
};

export default App;
